import { css } from "@emotion/react";

import { fontSize } from "~/client/styles/emotion/mixins/fontSize";
import tokens from "~/packages/design-tokens/dist/tokens";

export const folderWrapperCss = css({
  ".groupLabel": {
    marginTop: 0,
    marginBottom: 0,
  },
});

export const folderIconCss = css([
  fontSize(18),
  {
    ".ks": {
      display: "block",
      opacity: "0.8",
    },
    ".ks-folder": {
      fill: tokens.color.symbol.icon.green.value,
    },
  },
]);

export const folderCss = css({
  display: "grid",
  gridTemplateColumns: "min-content auto",
  columnGap: "6px",
  alignItems: "center",
  wordBreak: "break-word",
});
